import request from "@/utils/request";

// 全站数据
export function getAllpvuv(obj) {
	return request({
		url: "/admin/getAllpvuv",
		method: "post",
		data: obj,
	});
}

// 查询文章列表的数据
export function getWZListpvuv(obj) {
	return request({
		url: "/admin/getWZListpvuv",
		method: "post",
		data: obj,
	});
}
// 查询单篇文章的数据
export function getSingleWZpvuv(obj) {
	return request({
		url: "/admin/getSingleWZpvuv",
		method: "post",
		data: obj,
	});
}

// 获取每日明细数据
export function getDailyDetailPvuv(obj) {
	return request({
		url: "/admin/getDailyDetailPvuv",
		method: "post",
		data: obj,
	});
}

// 导航栏tag
export function tabTag(obj) {
	return request({
		url: "/admin/information/tabTag",
		method: "post",
		data: obj,
	});
}

export function dataeraList(obj) {
	return request({
		url: "/admin/dataera/lists",
		method: "post",
		data: obj,
	});
}
export function dataeraUpdate(obj) {
	return request({
		url: "/admin/dataera/update",
		method: "post",
		data: obj,
	});
}
